export default function Footer() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      {/* Main Footer */}
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-[1400px] mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8 md:gap-10">
            {/* Brand */}
            <div className="col-span-2 lg:col-span-1">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                  <i className="ri-play-circle-fill text-xl text-background-50"></i>
                </div>
                <span className="font-heading text-xl font-bold text-background-50 whitespace-nowrap">
                  51动漫
                </span>
              </div>
              <p className="text-sm text-foreground-400 leading-relaxed mb-4 max-w-[280px]">
                51动漫官方入口，免费日漫韩漫国漫全集下拉式在线阅读平台。每日同步更新，收藏追更，你的专属动漫乐园。
              </p>
              <div className="flex items-center gap-3">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">
                  <i className="ri-wechat-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">
                  <i className="ri-weibo-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">
                  <i className="ri-bilibili-line text-lg"></i>
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
              <ul className="space-y-2.5">
                {[
                  { label: '更新动态', href: '#updates' },
                  { label: '专题索引', href: '#index' },
                  { label: '热门榜单', href: '#ranking' },
                  { label: '焦点专题', href: '#carousel' },
                  { label: '常见问答', href: '#faq' },
                ].map((item) => (
                  <li key={item.href}>
                    <a
                      href={item.href}
                      onClick={(e) => handleScroll(e, item.href)}
                      className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Categories */}
            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">动漫分类</h4>
              <ul className="space-y-2.5">
                {['日漫热播', '韩漫精选', '国产动漫', '热血冒险', '恋爱校园'].map((item) => (
                  <li key={item}>
                    <a href="#index" onClick={(e) => handleScroll(e, '#index')} className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                      {item}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Support */}
            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">帮助支持</h4>
              <ul className="space-y-2.5">
                {[
                  { label: '关于我们', href: '#about' },
                  { label: '联系我们', href: '#contact' },
                  { label: '平台特色', href: '#features' },
                  { label: '常见问答', href: '#faq' },
                ].map((item) => (
                  <li key={item.href}>
                    <a
                      href={item.href}
                      onClick={(e) => handleScroll(e, item.href)}
                      className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Partners */}
            <div className="col-span-2 md:col-span-1">
              <h4 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h4>
              <p className="text-sm text-foreground-500 leading-relaxed">
                诚邀各大动漫内容方、平台方及品牌方合作，共同打造优质动漫生态。
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-foreground-800/30">
        <div className="w-full px-4 md:px-6 py-5">
          <div className="max-w-[1400px] mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">
              &copy; 2026 51动漫. 本站内容仅供学习交流，版权归原作者所有。
            </p>
            <div className="flex items-center gap-4 text-xs text-foreground-500">
              <span className="cursor-pointer hover:text-foreground-300 transition-colors">用户协议</span>
              <span className="cursor-pointer hover:text-foreground-300 transition-colors">隐私政策</span>
              <span className="cursor-pointer hover:text-foreground-300 transition-colors">版权声明</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}